import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "room_nav" }
const _hoisted_2 = { class: "room_title" }
const _hoisted_3 = { class: "title_text" }
const _hoisted_4 = { class: "room_timer" }
const _hoisted_5 = { class: "header_extra" }
const _hoisted_6 = {
  key: 0,
  class: "room_warning"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MeetingRoomHeader',
  props: {
    title: {},
    elapsedText: {},
    rtcJoined: { type: Boolean },
    showWarning: { type: Boolean },
    warningMinutes: {},
    screenFullscreen: { type: Boolean }
  },
  emits: ["leave"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["room_header", { screen_fullscreen: _ctx.screenFullscreen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "icon_button back_button",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('leave')))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("span", null, null, -1)
      ])),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("i", {
            class: _normalizeClass({ connected: _ctx.rtcJoined })
          }, null, 2),
          _createElementVNode("span", null, _toDisplayString(_ctx.elapsedText), 1)
        ])
      ]),
      _createElementVNode("button", {
        class: "leave_button",
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('leave')))
      }, _toDisplayString(_ctx.$t('离开')), 1),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "extra")
      ])
    ]),
    (_ctx.showWarning)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[3] || (_cache[3] = _createElementVNode("svg", {
            viewBox: "0 0 48 48",
            "aria-hidden": "true"
          }, [
            _createElementVNode("path", {
              d: "M22.1 8.4 4.7 38.5c-.9 1.6.2 3.5 2.1 3.5h34.4c1.9 0 3-2 2.1-3.5L25.9 8.4c-.8-1.6-3-1.6-3.8 0Z",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "3.5"
            }),
            _createElementVNode("path", {
              d: "M24 18v10",
              stroke: "currentColor",
              "stroke-width": "3.5",
              "stroke-linecap": "round"
            }),
            _createElementVNode("circle", {
              cx: "24",
              cy: "34",
              r: "2",
              fill: "currentColor"
            })
          ], -1)),
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('当前会议将在')), 1),
            _createElementVNode("em", null, _toDisplayString(_ctx.$t('{number}分钟', { number: _ctx.warningMinutes })), 1),
            _createTextVNode(_toDisplayString(_ctx.$t('后结束')), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})